import React, { Component } from "react";

const SAVE_STEPS = [
  {
    no: 1,
    code: "COPYWRITER",
    title: "AI 카피라이터 설정 저장",
    description: "분석 결과와 수정한 작성 기준을 카피라이터 설정으로 저장합니다.",
  },
  {
    no: 2,
    code: "AUTOMATION",
    title: "AI 콘텐츠 자동 생성 설정 생성 및 저장",
    description: "추천 발행 주기와 콘텐츠·이미지 생성 규칙을 자동화 설정으로 만듭니다.",
  },
  // {
  //   no: 3,
  //   code: "ANALYSIS_SNAPSHOT",
  //   title: "등록 당시 기업 분석 스냅샷 보존",
  //   description: "이 자동화에 사용한 기업 분석 결과를 별도 이력으로 보관합니다.",
  // },
];

class InstagramAutoSetupSaveProgressModal extends Component {
  getStepState = (stepNo) => {
    const status = String(this.props.status || "PROCESSING").toUpperCase();
    const currentStepNo = Number(this.props.currentStepNo || 1);
    const completedStepNo = Number(this.props.completedStepNo || 0);

    if (completedStepNo >= stepNo || status === "DONE") {
      return "done";
    }
    if (status === "FAILED" && currentStepNo === stepNo) {
      return "failed";
    }
    if (status === "PROCESSING" && currentStepNo === stepNo) {
      return "active";
    }
    return "pending";
  };

  getStepIcon = (step, stepState) => {
    if (stepState === "done") return "✓";
    if (stepState === "failed") return "!";
    if (stepState === "active") {
      return <span className="auto-save-modal-spinner" />;
    }
    return step.no;
  };

  getPublishCycleLabel = (publishCycle) => {
    const labels = {
      DAILY: "매일",
      BIDAY: "격일",
      WEEKLY: "매주",
      THREETIMES: "주 3회",
      CUSTOM: "지정 요일",
    };
    return labels[publishCycle] || publishCycle || "-";
  };

  getActiveWeekdays = (value) => {
    const values = Array.isArray(value)
      ? value
      : value === null || value === undefined || value === ""
      ? []
      : [value];

    const numberLabels = {
      1: "월",
      2: "화",
      3: "수",
      4: "목",
      5: "금",
      6: "토",
      7: "일",
    };
    const allowedLabels = ["월", "화", "수", "목", "금", "토", "일"];

    return values.reduce((days, item) => {
      let day = String(item ?? "").trim();
      if (!day) return days;

      if (numberLabels[day]) {
        day = numberLabels[day];
      } else {
        day = day.replace(/요일$/, "");
      }

      if (allowedLabels.includes(day) && !days.includes(day)) {
        days.push(day);
      }
      return days;
    }, []);
  };

  getScheduleLabel = (result) => {
    const publishCycleCode = String(
      result.publish_cycle || ""
    ).toUpperCase();
    const publishCycle = this.getPublishCycleLabel(publishCycleCode);
    const scheduledTime = result.scheduled_time || "";
    const activeWeekdays = this.getActiveWeekdays(
      result.active_weekdays || this.props.activeWeekdays
    );
    const shouldShowWeekdays = [
      "WEEKLY",
      "THREETIMES",
      "CUSTOM",
    ].includes(publishCycleCode);

    let weekdayLabel = "";
    if (shouldShowWeekdays && activeWeekdays.length === 1) {
      weekdayLabel = `${activeWeekdays[0]}요일`;
    } else if (shouldShowWeekdays && activeWeekdays.length > 1) {
      weekdayLabel = activeWeekdays.join(", ");
    }

    return [publishCycle, weekdayLabel, scheduledTime]
      .filter(Boolean)
      .join(" ");
  };

  handleOverlayClick = (event) => {
    if (event.target !== event.currentTarget) return;
    const status = String(this.props.status).toUpperCase();
    if (status === "PROCESSING" || status === "DONE") return;
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
  };

  renderContentRegistrationProgress = () => {
    const failed = String(this.props.status || "").toUpperCase() === "FAILED";
    const reusingCopywriter = Boolean(this.props.reuseCopywriter);
    const steps = [
      { no: 1, code: "COPYWRITER", title: "AI 카피라이터 설정 저장", description: reusingCopywriter
        ? "기존에 등록한 카피라이터 설정을 확인하고 재사용합니다. (중복 저장 없음)"
        : "미리보기에서 확인한 카피라이터 설정을 등록합니다." },
      { no: 2, code: "DRAFT", title: "콘텐츠 임시저장", description: "미리보기 이미지·문구·해시태그를 계정 미선택 상태로 저장합니다." },
    ];
    return (
      <div className="auto-save-modal-progress-view">
        <div className="auto-save-modal-symbol" aria-hidden="true">📝</div>
        <h2>{failed ? "콘텐츠 등록을 완료하지 못했습니다." : "콘텐츠 등록 중..."}</h2>
        <p className="auto-save-modal-description">
          {failed ? this.props.errorMessage || "저장 중 오류가 발생했습니다." :
            this.props.message || "카피라이터 설정과 콘텐츠 임시저장을 진행하고 있습니다."}
        </p>
        <div className="auto-save-modal-step-list">
          {steps.map((step) => {
            const state = this.getStepState(step.no);
            return (
              <div key={step.code} className={`auto-save-modal-step-item ${state}`}>
                <div className="auto-save-modal-step-icon">{this.getStepIcon(step, state)}</div>
                <div className="auto-save-modal-step-copy"><strong>{step.title}</strong><span>{step.description}</span></div>
                <div className="auto-save-modal-step-status">
                  {state === "done" ? "완료" : state === "active" ? "처리 중" : state === "failed" ? "실패" : "대기"}
                </div>
              </div>
            );
          })}
        </div>
        {failed && (
          <div className="auto-save-modal-error-actions">
            <button type="button" className="btn btn-primary" onClick={this.props.onRetry}>다시 시도</button>
            <button type="button" className="btn btn-outline" onClick={this.props.onClose}>닫기</button>
          </div>
        )}
      </div>
    );
  };

  renderContentRegistrationComplete = () => (
    <div className="auto-save-modal-complete-view">
      <div className="auto-save-modal-complete-icon">✓</div>
      <h2>콘텐츠 등록이 완료되었습니다!</h2>
      <p className="auto-save-modal-description">발행하지 않고 계정 미선택 상태로 임시저장했습니다.</p>
      <div className="auto-save-modal-result-box">
        <div className="auto-save-modal-result-title">생성 및 저장된 항목</div>
        <div className="auto-save-modal-result-row"><span>AI 카피라이터 설정</span>
          <span className="auto-save-modal-badge">
            {/* {this.props.result?.copywriter_reused ? "기존 설정 사용" : "완료"} */}
            {"완료"}
          </span>
        </div>
        <div className="auto-save-modal-result-row"><span>콘텐츠 등록</span><span className="auto-save-modal-badge">완료</span></div>
        {/* <div className="auto-save-modal-result-row"><span>Instagram/Threads 계정</span><span>미선택</span></div> */}
      </div>
      <div className="auto-save-modal-sub-actions">
        <button type="button" className="btn btn-grey" onClick={this.props.onOpenCopywriterSetting}>카피라이터 확인</button>
        <button type="button" className="btn btn-primary" onClick={this.props.onOpenDraftContent}>콘텐츠 확인</button>
      </div>
    </div>
  );

  renderProgressView = () => {
    if (this.props.contentRegistrationMode) return this.renderContentRegistrationProgress();
    const status = String(this.props.status || "PROCESSING").toUpperCase();
    const failed = status === "FAILED";

    if (this.props.profileUpdateMode) {
      return (
        <div className="auto-save-modal-progress-view">
          <div className="auto-save-modal-symbol" aria-hidden="true">
            🏢✨
          </div>
          <h2>
            {failed
              ? "기업정보 업데이트를 완료하지 못했습니다."
              : "기업정보 업데이트 중..."}
          </h2>
          <p className="auto-save-modal-description">
            {failed
              ? this.props.errorMessage || "저장 중 오류가 발생했습니다."
              : this.props.message ||
                "새 분석 결과를 기업정보 이력으로 저장하고 있습니다."}
          </p>
          {failed && (
            <div className="auto-save-modal-error-actions">
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.props.onRetry}
              >
                같은 요청 재시도
              </button>
              <button
                type="button"
                className="btn btn-outline"
                onClick={this.props.onClose}
              >
                닫기
              </button>
            </div>
          )}
        </div>
      );
    }

    return (
      <div className="auto-save-modal-progress-view">
        <div className="auto-save-modal-symbol" aria-hidden="true">
          🏢✨
        </div>
        <h2>
          {failed
            ? "자동화 세팅을 완료하지 못했습니다."
            : "AI 자동화 세팅 중..."}
        </h2>
        <p className="auto-save-modal-description">
          {failed
            ? this.props.errorMessage || "저장 중 오류가 발생했습니다."
            : this.props.message ||
              "카피라이터와 새 자동화를 만들고 등록 당시 분석본을 보존합니다."}
        </p>

        <div className="auto-save-modal-step-list">
          {SAVE_STEPS.map((step) => {
            const stepState = this.getStepState(step.no);
            return (
              <div
                key={step.code}
                className={`auto-save-modal-step-item ${stepState}`}
              >
                <div className="auto-save-modal-step-icon">
                  {this.getStepIcon(step, stepState)}
                </div>
                <div className="auto-save-modal-step-copy">
                  <strong>{step.title}</strong>
                  <span>{step.description}</span>
                </div>
                <div className="auto-save-modal-step-status">
                  {stepState === "done"
                    ? "완료"
                    : stepState === "active"
                    ? "처리 중"
                    : stepState === "failed"
                    ? "실패"
                    : "대기"}
                </div>
              </div>
            );
          })}
        </div>

        {failed && (
          <div className="auto-save-modal-error-actions">
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.props.onRetry}
            >
              다시 시도
            </button>
            <button
              type="button"
              className="btn btn-outline"
              onClick={this.props.onClose}
            >
              닫기
            </button>
          </div>
        )}
      </div>
    );
  };

  renderCompleteView = () => {
    if (this.props.contentRegistrationMode) return this.renderContentRegistrationComplete();
    const result = this.props.result || {};
    const scheduleLabel = this.getScheduleLabel(result);

    if (this.props.profileUpdateMode) {
      return (
        <div className="auto-save-modal-complete-view">
          <div className="auto-save-modal-complete-icon">✓</div>
          <h2>기업정보 업데이트가 완료되었습니다!</h2>
          <p className="auto-save-modal-description">
            기존 카피라이터와 자동화 설정은 변경하지 않고, 새 분석 결과만 현재 기업정보로 반영했습니다.
          </p>

          <div className="auto-save-modal-result-box">
            <div className="auto-save-modal-result-title">저장된 항목</div>
            <div className="auto-save-modal-result-row">
              <span>기업정보 새 분석본</span>
              <span className="auto-save-modal-badge">완료</span>
            </div>
          </div>

          <div className="auto-save-modal-actions">
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.props.onOpenCompanyRepository}
            >
              기업정보 보러가기
            </button>
          </div>
        </div>
      );
    }

    return (
      <div className="auto-save-modal-complete-view">
        <div className="auto-save-modal-complete-icon">✓</div>
        <h2>세팅이 완료되었습니다!</h2>
        <p className="auto-save-modal-description">
          카피라이터와 자동화 설정을 등록하였습니다.
        </p>

        <div className="auto-save-modal-result-box">
          <div className="auto-save-modal-result-title">
            생성 및 저장된 항목
          </div>
          <div className="auto-save-modal-result-row">
            <span>AI 카피라이터 설정</span>
            <span className="auto-save-modal-badge">
              완료
            </span>
          </div>
          <div className="auto-save-modal-result-row">
            <span>AI 콘텐츠 자동 생성 설정</span>
            <span className="auto-save-modal-badge">
              완료
            </span>
          </div>
          {/* <div className="auto-save-modal-result-row">
            <span>기업 분석 스냅샷</span>
            <span className="auto-save-modal-badge">
              완료
            </span>
          </div> */}
          <div className="auto-save-modal-result-row">
            <span>자동 발행 일정</span>
            <span className="auto-save-modal-badge schedule">
              {scheduleLabel}
            </span>
          </div>
        </div>

        <div className="auto-save-modal-actions">

          <div className="auto-save-modal-sub-actions">
            <button
              type="button"
              className="btn btn-grey"
              onClick={this.props.onOpenCopywriterSetting}
            >
              카피라이터 확인
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.props.onOpenAutomationSetting}
            >
              자동화 설정 확인
            </button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    if (!this.props.isOpen) return null;

    const status = String(this.props.status || "PROCESSING").toUpperCase();

    return (
      <div
        className="auto-save-modal-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="auto-save-modal-title"
        onClick={this.handleOverlayClick}
      >
        <style>{`
          .auto-save-modal-overlay {
            position: fixed;
            inset: 0;
            z-index: 200000;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px;
            background: rgba(10, 26, 47, .75);
            backdrop-filter: blur(4px);
          }
          .auto-save-modal-box {
            position: relative;
            width: 560px;
            max-width: 100%;
            max-height: calc(100vh - 40px);
            overflow-y: auto;
            padding: 32px;
            border-radius: 12px;
            background: #fff;
            box-shadow: 0 20px 40px rgba(0, 0, 0, .3);
            color: #0a1a2f;
            text-align: center;
          }
          .auto-save-modal-box h2 {
            margin: 0 0 6px;
            color: #0a1a2f;
            font-size: 20px;
            font-weight: 800;
          }
          .auto-save-modal-symbol {
            margin-bottom: 8px;
            font-size: 32px;
          }
          .auto-save-modal-description {
            margin: 0;
            color: #6b7280;
            font-size: 13px;
            line-height: 1.6;
          }
          .auto-save-modal-step-list {
            display: flex;
            flex-direction: column;
            gap: 10px;
            margin-top: 22px;
            text-align: left;
          }
          .auto-save-modal-step-item {
            display: grid;
            grid-template-columns: 28px minmax(0, 1fr) auto;
            align-items: center;
            gap: 12px;
            padding: 14px 16px;
            border: 1px solid #e5e7eb;
            border-radius: 9px;
            background: #f8fafc;
            opacity: .45;
            transition: all .2s ease;
          }
          .auto-save-modal-step-item.active {
            border-color: #00e2e6;
            background: #f0fdfe;
            opacity: 1;
          }
          .auto-save-modal-step-item.done {
            border-color: #cbd5e1;
            background: #fff;
            opacity: 1;
          }
          .auto-save-modal-step-item.failed {
            border-color: #fca5a5;
            background: #fff7f7;
            opacity: 1;
          }
          .auto-save-modal-step-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 28px;
            height: 28px;
            border-radius: 50%;
            background: #e2e8f0;
            color: #64748b;
            font-size: 12px;
            font-weight: 800;
          }
          .auto-save-modal-step-item.active .auto-save-modal-step-icon {
            background: #00e2e6;
            color: #0a1a2f;
          }
          .auto-save-modal-step-item.done .auto-save-modal-step-icon {
            background: #10b981;
            color: #fff;
          }
          .auto-save-modal-step-item.failed .auto-save-modal-step-icon {
            background: #ef4444;
            color: #fff;
          }
          .auto-save-modal-spinner {
            width: 12px;
            height: 12px;
            border: 2px solid rgba(10, 26, 47, .25);
            border-top-color: #0a1a2f;
            border-radius: 50%;
            animation: autoSaveModalSpin .7s linear infinite;
          }
          @keyframes autoSaveModalSpin { to { transform: rotate(360deg); } }
          .auto-save-modal-step-copy {
            display: flex;
            min-width: 0;
            flex-direction: column;
            gap: 3px;
          }
          .auto-save-modal-step-copy strong {
            font-size: 13px;
            line-height: 1.4;
          }
          .auto-save-modal-step-copy span {
            color: #6b7280;
            font-size: 11px;
            line-height: 1.45;
          }
          .auto-save-modal-step-status {
            color: #64748b;
            font-size: 11px;
            font-weight: 700;
            white-space: nowrap;
          }
          .auto-save-modal-step-item.active .auto-save-modal-step-status { color: #008b8f; }
          .auto-save-modal-step-item.done .auto-save-modal-step-status { color: #059669; }
          .auto-save-modal-step-item.failed .auto-save-modal-step-status { color: #dc2626; }
          .auto-save-modal-complete-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 52px;
            height: 52px;
            margin: 0 auto 14px;
            border: 2px solid #00e2e6;
            border-radius: 50%;
            background: rgba(0, 226, 230, .1);
            color: #008b8f;
            font-size: 24px;
            font-weight: 900;
          }
          .auto-save-modal-result-box {
            margin: 22px 0;
            padding: 16px;
            border: 1px solid #e5e7eb;
            border-radius: 9px;
            background: #f8fafc;
            text-align: left;
          }
          .auto-save-modal-result-title {
            margin-bottom: 8px;
            color: #6b7280;
            font-size: 11px;
            font-weight: 700;
          }
          .auto-save-modal-result-row {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            padding: 9px 0;
            border-bottom: 1px dashed #e5e7eb;
            color: #0a1a2f;
            font-size: 13px;
            font-weight: 600;
          }
          .auto-save-modal-result-row:last-child { border-bottom: 0; }
          .auto-save-modal-badge {
            padding: 3px 9px;
            border-radius: 12px;
            background: #e0f2fe;
            color: #0284c7;
            font-size: 11px;
            font-weight: 700;
          }
          .auto-save-modal-badge.schedule {
            background: #fef3c7;
            color: #d97706;
          }
          .auto-save-modal-actions,
          .auto-save-modal-error-actions {
            display: flex;
            flex-direction: column;
            gap: 9px;
          }
          .auto-save-modal-error-actions { margin-top: 18px; }
          .auto-save-modal-sub-actions {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 8px;
          }
          .auto-save-modal-box .btn {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 44px;
            padding: 0 16px;
            border: 0;
            border-radius: 8px;
            font-size: 13px;
            font-weight: 700;
            cursor: pointer;
            transition: 0.2s;
          }
          .auto-save-modal-box .btn-primary {
            background: #00e2e6;
            color: #0a1a2f;
            box-shadow: 0 4px 12px rgba(0, 226, 230, .2);
          }
          .auto-save-modal-box .btn-primary:hover {
            background: #00bfc2;
            color: #0a1a2f;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 226, 230, .3);
          }  
          .auto-save-modal-box .btn-grey {
            background: #F2F2F2;
            color: #0a1a2f;
            box-shadow: 0 4px 12px #f2f2f20e;
          }
          .auto-save-modal-box .btn-grey:hover {
            background: #d1d1d1;
            color: #0a1a2f;
            transform: translateY(-1px);
            box-shadow: 0 4px 12px #f2f2f20e;
          }
          .auto-save-modal-box .btn-outline {
            border: 1px solid #cbd5e1;
            background: #fff;
            color: #0a1a2f;
          }
          .auto-save-modal-box .btn-outline:hover {
            border-color: #00e2e6 !important;
            color: #0a1a2f;
            background: #f0fdfe !important;
          }
          .auto-save-modal-close-button {
            position: absolute;
            top: 12px;
            right: 12px;
            z-index: 2;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            width: 34px;
            height: 34px;
            padding: 0;
            border: 0;
            border-radius: 8px;
            background: transparent;
            color: #64748b;
            font-size: 26px;
            line-height: 1;
            cursor: pointer;
          }
          .auto-save-modal-close-button:hover {
            background: #f1f5f9;
            color: #0a1a2f;
          }
          .auto-save-modal-close-button:focus-visible {
            outline: 2px solid #00bfc2;
            outline-offset: 2px;
          }
          @media (max-width: 560px) {
            .auto-save-modal-box { padding: 24px 18px; }
            .auto-save-modal-step-item {
              grid-template-columns: 28px minmax(0, 1fr);
            }
            .auto-save-modal-step-status {
              grid-column: 2;
            }
            .auto-save-modal-sub-actions { grid-template-columns: 1fr; }
          }
        `}</style>

        <div className="auto-save-modal-box" id="auto-save-modal-title">
          {(status === "DONE" || status === "FAILED") && (
            <button
              type="button"
              className="auto-save-modal-close-button"
              aria-label="닫기"
              title="닫기"
              onClick={this.props.onClose}
            >
              ×
            </button>
          )}
          {status === "DONE"
            ? this.renderCompleteView()
            : this.renderProgressView()}
        </div>
      </div>
    );
  }
}

export default InstagramAutoSetupSaveProgressModal;